import { render, staticRenderFns } from "./LicitacaoFornecedorReadequacaoProposta.vue?vue&type=template&id=19aefeea"
import script from "./LicitacaoFornecedorReadequacaoProposta.vue?vue&type=script&lang=js"
export * from "./LicitacaoFornecedorReadequacaoProposta.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoFornecedorReadequacaoProposta.vue?vue&type=style&index=0&id=19aefeea&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports